module.exports = __webpack_public_path__ + "img/excellent.9a680b2a.png";